<template>
  <b-modal
      id="modal-cliente"
      ref="modalCliente"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      size="xl"
  >
    <template #modal-title>
      Selecione um Cliente
    </template>
    <b-card>
      <b-col class="mt-1 mb-1">
        <b-row class="col-12">
          <b-col md="2">
            <b-form-group label="Código">
              <b-form-input type="text" v-model="searchCodigo" @input="fetchDataFromCliente"/>
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group label="Nome Fantasia">
              <b-form-input type="text" v-model="searchDescricao" @input="fetchDataFromCliente"/>
            </b-form-group>
          </b-col>
          <b-col class="mt-2" cols="2" md="1">
            <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="danger"
                class="w-100"
                @click="clearFilters"
            >
              <feather-icon icon="TrashIcon" size="18" />
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-card>
    <div v-if="loading" class="d-flex justify-content-center my-3">
      <b-spinner label="Loading..." />
    </div>
    <b-table
        class="position-relative"
        responsive
        :items="paginatedItems"
        show-empty
        empty-text="Nenhum registro encontrado"
        :fields="fields">
      <template #cell(actions)="data">
        <b-button @click="selectItem(data.item)" variant="primary">Selecionar</b-button>
      </template>
    </b-table>
    <div class="mx-2 mb-2">
      <b-row>
<!--        <b-col-->
<!--            cols="12"-->
<!--            sm="6"-->
<!--            class="d-flex align-items-center justify-content-center justify-content-sm-start"-->
<!--        >-->
<!--            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{-->
<!--                dataMeta.of-->
<!--              }} entries</span>-->
<!--        </b-col>-->
        <!-- Pagination -->
        <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >
          <b-pagination
              v-model="currentPage"
              :total-rows="totalItems"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
          >
            <template #prev-text>
              <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
              />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>
<!--    <b-pagination-->
<!--        v-model="currentPage"-->
<!--        :total-rows="totalItems"-->
<!--        :per-page="perPage"-->
<!--        class="d-flex justify-content-center mt-3"-->
<!--        :last-nav="true"-->
<!--        -->
<!--    ></b-pagination>-->
  </b-modal>
</template>

<script>
import {
  BButton,
  BCard,
  BCol,
  BFormGroup,
  BModal,
  BRow,
  BPagination,
  BTable,
  BFormInput,
} from 'bootstrap-vue';
import axios from '@/libs/axios';

export default {
  components: {
    BFormGroup,
    BCol,
    BCard,
    BButton,
    BModal,
    BRow,
    BPagination,
    BTable,
    BFormInput,
  },

  data() {
    return {
      clientes: [],
      searchCodigo: '',
      searchDescricao: '',
      currentPage: 1,
      perPage: 10,
      totalItems: 0,
      loading: false,
      fields: [
        { key: 'value', label: 'Código' },
        { key: 'clienteiderp', label: 'Codigo ERP' },
        { key: 'text', label: 'Nome Fantasia' },
        { key: 'actions', label: 'Ações' },
      ],
    };
  },
  watch: {
    currentPage: 'fetchDataFromCliente',
  },
  mounted() {
    this.fetchDataFromCliente();
  },
  computed: {
    paginatedItems() {
      return this.clientes;
    },
  },
  methods: {
    async fetchDataFromCliente() {
      this.loading = true; // Show the spinner
      try {
        const response = await axios.get('/cliente', {
          params: {
            page: this.currentPage,
            perPage: this.perPage,
            sortBy: 'clienterazaosocial',
            sortDesc: false,
            q: this.searchDescricao || this.searchCodigo,
          },
        });
        this.clientes = response.data.data.map((option) => ({
          value: option.clienteid,
          text: option.clientenomefantasia,
          clienteiderp: option.clienteiderp,
        }));
        this.totalItems = response.data.total;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      } finally {
        this.loading = false; // Hide the spinner
      }
    },
    show() {
      this.$bvModal.show('modal-cliente');
    },
    selectItem(cliente) {
      this.$emit('select-cliente', cliente);
      this.$bvModal.hide('modal-cliente');
    },
    clearFilters() {
      this.searchCodigo = '';
      this.searchDescricao = '';
      this.currentPage = 1;
      this.fetchDataFromCliente(); // Refresh data with cleared filters
    },
  },
};
</script>
